import styled, { ThemeProvider } from "styled-components";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import { GlobalStyles } from "./Styles/Global";
import Status from "./Status";
import Login from "./Login";
import AdminSettings from "./AdminSettings";

const StyledApp = styled.div`
  height: 100vh;
  width: 100vw;
`;

const BuildVersion = styled.h2`
  position: absolute;
  bottom: 0;
  right: 1vw;
`;

function App() {
  return (
    <ThemeProvider
      theme={{
        font: "roboto",
        colors: {
          text: "#000",
          border: "#000",
          primary: "#2a3142",
          highlight: "#4a6283",
          secondary: "#374151",
          background: "#1f2937",
        },
      }}
    >
      <GlobalStyles />
      <StyledApp>
        <Router>
          {process.env.NODE_ENV === "development" && (
            <BuildVersion>{process.env.NODE_ENV}</BuildVersion>
          )}

          <Routes>
            <Route path="/edabstatus" element={<Status />}></Route>
            <Route path="/admin" element={<AdminSettings />}></Route>
            <Route path="/" element={<Login />}></Route>
          </Routes>
        </Router>
      </StyledApp>
    </ThemeProvider>
  );
}

export default App;
